<template>
    <div class="ui bottom fixed menu" id="footer">
    <div class="ui content" id="footerText">
      <a href="http://hapiick.com"><i class="home icon"></i>www.hapiick.com</a>
      <i class="info circle icon"></i> 943 177 199
    </div>
  </div>
</template>


<script>
export default {
  name: 'Header',
  data() {
    return {
      apmName: null,
    }
  },
}
</script>

<style scoped>
a {
  color: black!important;
  margin-right: 10px;
}

#footerText {
  font-size: 13px;
  color: black;
  font-weight: bold!important;
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: white;
}

.ui.fixed.menu, .ui[class*="top fixed"].menu {
  height: 5%;
}

.ui.menu {
  display: unset;
  border: none;
  box-shadow: unset!important;
  min-height: 25px!important;
}

.imgHapiick {
  width: 75px!important;
}
</style>
